import styled from 'styled-components';
import BreakfastSvg from '../../assets/amenities/breakfast.svg';

const BreakfastIcon = styled(BreakfastSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default BreakfastIcon;
